// Copyright (c) 2022 by Move Closer

import { VueConstructor } from 'vue'
import { inject } from '@vue/composition-api'

/**
 * Injection key under which the DSL configuration should be registered within the app.
 *
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const DSL_CONFIG_INJECTION_KEY = Symbol.for('$dsl')

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export interface CustomDSLConfiguration {
  /**
   * Available SVG iconsMap.
   */
  icons?: Record<string, VueConstructor>

  /**
   * The string that should be used to prefix each component's name.
   *
   * @default "Ui"
   */
  prefix?: string
}

/**
 * Resolves the provided DSL configuration object.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const getDSLConfig = <Config extends {[key: string]: any}> (): Config => {
  const config = inject<Config>(DSL_CONFIG_INJECTION_KEY)

  if (typeof config === 'undefined') {
    throw new Error(`getDSLConfig(): FATAL ERROR! Failed to inject the DSL configuration! Did you provide the configuration object under the [${DSL_CONFIG_INJECTION_KEY.toString()}] InjectionKey?`)
  }

  return config
}
